import React from "react";

import classes from "../SignupPage/Signup.module.css";
import Button from "../../components/SignupLogin/Button";
import LoginForm from "./LoginForm";
import LoginHero from "./LoginHero";

import { AiOutlineGoogle, AiFillFacebook } from "react-icons/ai";

const Login = () => {
  return (
    <div className={classes.signup_layout}>
      <LoginHero />
      <form action="http://localhost:8081/users/auth/google">
        <Button
          type={{
            description: "Login with Google",
            color: "#019BFE",
            icon: <AiOutlineGoogle className={classes.icon} />,
          }}
        />
      </form>

      <form action="http://localhost:8081/users/auth/facebook">
        <Button
          type={{
            description: "Login with Facebook",
            color: "#3B5998",
            icon: <AiFillFacebook className={classes.icon} />,
          }}
        />
      </form>

      <span className={classes.or}>or</span>
      <LoginForm />
    </div>
  );
};

export default Login;
